/**
 * Forgot Password
 * ------------------------------------------------------------------------------
 * Account details - change password functionality
 *
 * @namespace custom
 */
import SENTRY from '../custom/sentry.js';

custom.forgotPassword = (() => {
  // Static Classnames
  const className = 'js-forgot-password';
  const errorClassName = `${className}--error`;
  const statusClassName = `${className}--status`;

  const response = {
    success: function (email) {
      return `We've sent password reset email to ${email} to set a new password.`;
    },
    error:
      'An error occurred. Please email customerservice@loloirugs.com for assistance.',
  };

  /**
   * errorHandler
   *
   * @param {string} msg - Error message to display
   *
   * When validation catches error, show error.
   */
  function errorHandler(msg = '') {
    msg = msg != '' ? msg : response.error;
    $(`.${className}`).addClass('error');
    $(`.${errorClassName}`).html(`<li>${msg}</li>`);
    custom.utils.sendCustomSentryError(
      `Reset Password Email Failed`,
      {
        extra: {error: msg},
        tags: {module: 'Forgot Password', category: SENTRY.CATEGORIES.LOGIN},
      },
    );
  }

  /**
   * successHandler
   *
   * @param {string} msg - Email address to submit
   *
   * Once past the validation, show indication of notification email being sent.
   */
  function successHandler(msg = '') {
    $(`.${className}`).removeClass('error');
    $(`.${errorClassName}`).html('');
    $(`.${statusClassName}`).removeClass('hidden').text(msg);
    setTimeout(() => {
      $(`.${statusClassName}`).addClass('hidden');
    }, 5000);
  }

  /**
   * submit
   *
   * @param {object} form - Form DOM object
   * @param {string} email - Email address in input field
   *
   * Trigger the forgot password submission via Ajax.
   * This method would be public so that any other module can use
   * this and have different callback function
   */
  function submit(
    form = null,
    successCallback = () => {},
    errorHandler = () => {},
  ) {
    const email = $(form)
      .serializeArray()
      .filter((attribute) => attribute.name == 'email')[0].value;

    return $.ajax({
      type: 'POST',
      url: '/account/recover',
      // dataType: "json",
      data: $(form).serialize() + '&form_type=recover_customer_password&utf8=✓',
      success: function () {
        successCallback(response.success(email));
      },
      error: function () {
        errorHandler();
      },
    });
  }

  /**
   * handler
   *
   * @param {object} evt - Submit event object
   *
   * Handler to trigger Ajax submit, and callbacks
   */
  function handler(evt = null) {
    evt.preventDefault();
    const $form = $(evt.currentTarget);

    submit($form, successHandler, errorHandler);
  }

  function init() {
    if ($(`.${className}`).length > 0) $(`.${className}`).on('submit', handler);
  }

  return {
    init,
    submit,
    response,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/forgot-password.js